import { frontendURL } from 'dashboard/helper/URLHelper';

const CampaignsRouteView = () => import('./pages/CampaignsRouteView.vue');
const CampaignsHomePage = () => import('./pages/CampaignsHomePage.vue');
const BroadcastsListTabPage = () => import('./pages/BroadcastsListTabPage.vue');
const EmailCampaignsListPage = () =>
  import('./pages/EmailCampaignsListPage.vue');
const CampaignNewPage = () => import('./pages/CampaignNewPage.vue');
const EmailTemplateEditPage = () => import('./pages/EmailTemplateEditPage.vue');
const WhatsAppTemplatesHubPage = () =>
  import('./pages/WhatsAppTemplatesHubPage.vue');
const CampaignsSettingsPage = () => import('./pages/CampaignsSettingsPage.vue');
const FlowsListPage = () => import('./pages/FlowsListPage.vue');
const FlowInsightsPage = () => import('./pages/FlowInsightsPage.vue');
const FlowPeoplePage = () => import('./pages/FlowPeoplePage.vue');

const meta = {
  permissions: [
    'administrator',
    'broadcast_view',
    'broadcast_create',
    'broadcast_manage',
  ],
};

const campaignsRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/campaigns'),
      component: CampaignsRouteView,
      children: [
        {
          path: '',
          name: 'campaigns_index',
          meta,
          component: CampaignsHomePage,
        },
        {
          path: 'broadcasts',
          name: 'broadcasts_list',
          meta,
          component: BroadcastsListTabPage,
        },
        {
          path: 'email',
          name: 'email_campaigns_index',
          meta,
          component: EmailCampaignsListPage,
        },
        {
          path: 'new',
          name: 'campaigns_new',
          meta,
          component: CampaignNewPage,
        },
        {
          path: 'settings',
          name: 'campaigns_settings',
          meta,
          component: CampaignsSettingsPage,
        },
        {
          path: 'email-templates/new',
          name: 'email_template_new',
          meta,
          component: EmailTemplateEditPage,
        },
        {
          path: 'email-templates/:templateId',
          name: 'email_template_edit',
          meta,
          component: EmailTemplateEditPage,
        },
        {
          path: 'whatsapp-templates',
          name: 'whatsapp_templates_hub',
          meta,
          component: WhatsAppTemplatesHubPage,
        },
        // Fluxos de marketing: mesma maquina dos workflows, casa de marketing
        {
          path: 'flows',
          name: 'marketing_flows_index',
          meta: {
            permissions: ['administrator', 'workflow_view', 'workflow_manage'],
          },
          component: FlowsListPage,
        },
        {
          path: 'flows/:flowId/people',
          name: 'marketing_flow_people',
          meta: {
            permissions: ['administrator', 'workflow_view', 'workflow_manage'],
          },
          component: FlowPeoplePage,
        },
        {
          path: 'flows/:flowId',
          name: 'marketing_flow_show',
          meta: {
            permissions: ['administrator', 'workflow_view', 'workflow_manage'],
          },
          component: FlowInsightsPage,
        },
      ],
    },
  ],
};

export default campaignsRoutes;
